import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bordered-card bordered-card_secondary members-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, "Members Information", -1)
const _hoisted_3 = { class: "d-flex flex-column align-items-start gap-20 w-100" }
const _hoisted_4 = { class: "d-flex align-items-center gap-10 w-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-search w-5" }, null, -1)
const _hoisted_6 = { class: "d-flex align-items-center gap-10 w-100" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-calendar w-5" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-Hand-Pills fs-lg w-5" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript;",
  class: "fs-sm"
}, " Member Contributions Inquiry ", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "d-flex align-items-center gap-10 w-100" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-note fs-lg w-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_router_link, {
          class: "fs-sm",
          to: { name: 'local.member-search' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Member Search ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_router_link, {
          class: "fs-sm",
          to: { name: 'local.coverage-search' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Member Current Coverage Search ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", {
        class: "d-flex align-items-center gap-10 w-100 plan-modal",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('local-missing-contributions', 'Missing Contributions Inquiry', 'plan-upload plan-card-info plan-profile-update')), ["prevent"]))
      }, _hoisted_10),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("a", {
          href: "javascript;",
          class: "plan-modal fs-sm",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: _ctx.cappReport })), ["prevent"]))
        }, " CAPP Analysis Report ")
      ])
    ])
  ]))
}